import React from 'react';
import styled from 'styled-components';

const Container = styled.div`
  /* position: fixed; */
  top: 0;
  left: 0;
  width: 100%;
  height: ${window.innerHeight/2 + 'px'};
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
`;

function Loading() {
  return (
    <Container>
      <div className="lds-ellipsis">
        <div />
        <div />
        <div />
        <div />
      </div>
    </Container>
  );
}

export default Loading;
